import { createContext } from "react";

const DF_MO0006Context = createContext();

export { DF_MO0006Context };
